import { render, staticRenderFns } from "./ChatMediaGallery.vue?vue&type=template&id=0332e078&scoped=true"
import script from "./ChatMediaGallery.vue?vue&type=script&lang=js"
export * from "./ChatMediaGallery.vue?vue&type=script&lang=js"
import style0 from "./ChatMediaGallery.vue?vue&type=style&index=0&id=0332e078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0332e078",
  null
  
)

export default component.exports